import script from "./PendingOrdersList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PendingOrdersList.vue?vue&type=script&setup=true&lang=ts"

import "./PendingOrdersList.vue?vue&type=style&index=0&id=8ad71322&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ad71322"]])

export default __exports__